import { Div, Label, Touchable } from "@grassrootly/rn-core";
import { Image } from "react-native";
import { PlayerGroupExperience } from "@grassrootly/api";
import { images } from "../../../layout/assets";
import { MainStackScreenProps } from "../../../navigation/Navigation.types";

interface PlayerGroupsProps {
  groups: PlayerGroupExperience[];
  navigation?: MainStackScreenProps<"eqipa-card">["navigation"];
}

export default function PlayerGroups({ groups, navigation }: PlayerGroupsProps) {
  const handleGroupPress = (groupId: number) => {
    if (navigation) {
      navigation.navigate("group", { id: groupId });
    }
  };

  return (
    <Div classNames={["w100", "maxW-{420}", "ml-{auto}", "mr-{auto}"]}>
      {groups && groups.length > 0 ? (
        groups.map((g) => (
          <Touchable 
            key={`${g.group_id}`} 
            onPress={() => handleGroupPress(g.group_id)}
            classNames={["flexRow", "justifyContentSpaceBetween", "alignItemsCenter", "pv8", "bwBottom-{1}", "borderSolid", "borderSecondary"]}
          >
            <Div classNames={["flexRow", "alignItemsCenter", "flex1"]}>
              <Image
                source={g.group_logo ? { uri: g.group_logo } : images.groupAvatar}
                style={{ width: 32, height: 32, borderRadius: 16, marginRight: 12 }}
                resizeMode="cover"
              />
              <Label>{g.group_name}</Label>
            </Div>
            <Label>{g.points_earned} exp.</Label>
          </Touchable>
        ))
      ) : (
        <Label type="l3Regular">No teams to display</Label>
      )}
    </Div>
  );
}
